module.exports = __webpack_public_path__ + "static/media/Home-Square.09159f72.jpg";